import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const GET_DEMAND_DETAILS = createRequestTypes('placement/demand/GET_DEMAND_DETAILS');
export const GET_USER_DETAILS = createRequestTypes('placement/demand/GET_USER_DETAILS');
export const GET_TRANSACTIONS = createRequestTypes('placement/demand/demand/GET_TRANSACTIONS');
export const GET_DEMAND_CONFIG = createRequestTypes('placement/demand/GET_DEMAND_CONFIG');
export const GET_DEMAND_VEHICLES = createRequestTypes('placement/demand/GET_DEMAND_VEHICLES');
export const GET_EXPENSE_DETAILS = createRequestTypes('placement/demand/GET_EXPENSE_DETAILS');
export const UPDATE_DEMAND_DETAILS = createRequestTypes('placement/demand/UPDATE_DEMAND_DETAILS');
export const UPDATE_FREIGHT_DETAILS = createRequestTypes('placement/demand/UPDATE_FREIGHT_DETAILS');
export const UPLOAD_FREIGHT = createRequestTypes('placement/demand/UPLOAD_FREIGHT');
export const CLEAR_FREIGHT_NAME = createRequestTypes('placement/demand/CLEAR_FREIGHT_NAME');
export const ADD_EXPENSE = createRequestTypes('placement/demand/ADD_EXPENSE');
export const EDIT_EXPENSE = createRequestTypes('placement/demand/EDIT_EXPENSE');
export const GET_EXPENSE_TYPES = createRequestTypes('placement/demand/GET_EXPENSE_TYPES');
export const SETTLE_EXPENSE = createRequestTypes('placement/demand/SETTLE_EXPENSE');
export const GET_REMARKS = createRequestTypes('placement/demand/GET_REMARKS');
export const GET_BANK_DETAILS = createRequestTypes('placement/demand/GET_BANK_DETAILS');
export const EDIT_TRANSACTION = createRequestTypes('placement/demand/EDIT_TRANSACTION');
export const CREATE_TRANSACTION = createRequestTypes('placement/demand/CREATE_TRANSACTION');
export const GET_EMAILS_LIST = createRequestTypes('placement/demand/GET_EMAILS_LIST');
export const ASSIGN_INDENT = createRequestTypes('placement/demand/ASSIGN_INDENT');
export const DELETE_EXPENSE = createRequestTypes('placement/demand/DELETE_EXPENSE');
export const GET_CONSIGNERS = createRequestTypes('placement/demand/GET_CONSIGNERS');
export const GET_MATERIAL_DETAILS = createRequestTypes('placement/GET_MATERIAL_DETAILS');
export const GET_MATERIAL_TYPES = createRequestTypes('placement/demand/GET_MATERIAL_TYPES');
export const CREATE_MATERIAL_DETAILS = createRequestTypes('placement/demand/CREATE_MATERIAL_DETAILS');
export const GET_NBFC_EXPENSE = createRequestTypes('placement/demand/GET_NBFC_EXPENSE');
export const GET_PTL_DETAILS = createRequestTypes('placement/demand/GET_PTL_DETAILS');
export const UPDATE_PTL_METADATA_DETAILS = createRequestTypes('placement/demand/UPDATE_PTL_METADATA_DETAILS');
export const GET_GST_DETAILS = createRequestTypes('placement/demand/GET_GST_DETAILS');

export const getMaterialDetails = {
  request: (params) => createAction(GET_MATERIAL_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_MATERIAL_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_MATERIAL_DETAILS[FAILURE], { response }),
};

export const getMaterialTypes = {
  request: (params) => createAction(GET_MATERIAL_TYPES[REQUEST], { params }),
  success: (response) => createAction(GET_MATERIAL_TYPES[SUCCESS], { response }),
  failure: (response) => createAction(GET_MATERIAL_TYPES[FAILURE], { response }),
};

export const getDemandDetails = {
  request: (params) => createAction(GET_DEMAND_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_DEMAND_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_DEMAND_DETAILS[FAILURE], { response }),
};

export const getConsigners = {
  request: (params) => createAction(GET_CONSIGNERS[REQUEST], { params }),
  success: (response) => createAction(GET_CONSIGNERS[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNERS[FAILURE], { response }),
};

export const getUserDetails = {
  request: (params) => createAction(GET_USER_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_USER_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_USER_DETAILS[FAILURE], { response }),
};

export const getTransactions = {
  request: (params) => createAction(GET_TRANSACTIONS[REQUEST], { params }),
  success: (response) => createAction(GET_TRANSACTIONS[SUCCESS], { response }),
  failure: (response) => createAction(GET_TRANSACTIONS[FAILURE], { response }),
};

export const getDemandConfig = {
  request: () => createAction(GET_DEMAND_CONFIG[REQUEST]),
  success: (response) => createAction(GET_DEMAND_CONFIG[SUCCESS], { response }),
  failure: (response) => createAction(GET_DEMAND_CONFIG[FAILURE], { response }),
};
export const getDemandVehicles = {
  request: (params) => createAction(GET_DEMAND_VEHICLES[REQUEST], { params }),
  success: (response) => createAction(GET_DEMAND_VEHICLES[SUCCESS], { response }),
  failure: (response) => createAction(GET_DEMAND_VEHICLES[FAILURE], { response }),
};

export const getExpenseDetails = {
  request: (params) => createAction(GET_EXPENSE_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_EXPENSE_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_EXPENSE_DETAILS[FAILURE], { response }),
};

export const updateDemandDetails = {
  request: (payload) => createAction(UPDATE_DEMAND_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_DEMAND_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_DEMAND_DETAILS[FAILURE], { response }),
};

export const deleteExpense = {
  request: (payload) => createAction(DELETE_EXPENSE[REQUEST], { payload }),
  success: (response) => createAction(DELETE_EXPENSE[SUCCESS], { response }),
  failure: (response) => createAction(DELETE_EXPENSE[FAILURE], { response }),
};

export const updateFreightDetails = {
  request: (payload) => createAction(UPDATE_FREIGHT_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_FREIGHT_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_FREIGHT_DETAILS[FAILURE], { response }),
};

export const uploadFreight = {
  request: (params) => createAction(UPLOAD_FREIGHT[REQUEST], { params }),
  success: (response) => createAction(UPLOAD_FREIGHT[SUCCESS], { response }),
  failure: (response) => createAction(UPLOAD_FREIGHT[FAILURE], { response }),
  clearFreightName: () => createAction(CLEAR_FREIGHT_NAME),
};

export const addExpense = {
  request: (payload) => createAction(ADD_EXPENSE[REQUEST], { payload }),
  success: (response) => createAction(ADD_EXPENSE[SUCCESS], { response }),
  failure: (response) => createAction(ADD_EXPENSE[FAILURE], { response }),
};

export const settleExpense = {
  request: (payload) => createAction(SETTLE_EXPENSE[REQUEST], { payload }),
  success: (response) => createAction(SETTLE_EXPENSE[SUCCESS], { response }),
  failure: (response) => createAction(SETTLE_EXPENSE[FAILURE], { response }),
};

export const editExpense = {
  request: (payload) => createAction(EDIT_EXPENSE[REQUEST], { payload }),
  success: (response) => createAction(EDIT_EXPENSE[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_EXPENSE[FAILURE], { response }),
};

export const getEmailsList = {
  request: (params) => createAction(GET_EMAILS_LIST[REQUEST], { params }),
  success: (response, params) => createAction(GET_EMAILS_LIST[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_EMAILS_LIST[FAILURE], { response }),
};

export const assignIndent = {
  request: (payload) => createAction(ASSIGN_INDENT[REQUEST], { payload }),
  success: (response, payload) => createAction(ASSIGN_INDENT[SUCCESS], { response, payload }),
  failure: (response) => createAction(ASSIGN_INDENT[FAILURE], { response }),
};

export const getExpenseTypes = {
  request: (params) => createAction(GET_EXPENSE_TYPES[REQUEST], { params }),
  success: (response) => createAction(GET_EXPENSE_TYPES[SUCCESS], { response }),
  failure: (response) => createAction(GET_EXPENSE_TYPES[FAILURE], { response }),
};

export const getRemarks = {
  request: (params) => createAction(GET_REMARKS[REQUEST], { params }),
  success: (response) => createAction(GET_REMARKS[SUCCESS], { response }),
  failure: (response) => createAction(GET_REMARKS[FAILURE], { response }),
};

export const getBankDetails = {
  request: (params) => createAction(GET_BANK_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_BANK_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_BANK_DETAILS[FAILURE], { response }),
};

export const editTransaction = {
  request: (payload) => createAction(EDIT_TRANSACTION[REQUEST], { payload }),
  success: (response) => createAction(EDIT_TRANSACTION[SUCCESS], { response }),
  failure: (response) => createAction(EDIT_TRANSACTION[FAILURE], { response }),
};

export const createTransaction = {
  request: (payload) => createAction(CREATE_TRANSACTION[REQUEST], { payload }),
  success: (response) => createAction(CREATE_TRANSACTION[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_TRANSACTION[FAILURE], { response }),
};

export const createMaterialDetails = {
  request: (payload) => createAction(CREATE_MATERIAL_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(CREATE_MATERIAL_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_MATERIAL_DETAILS[FAILURE], { response }),
};

export const getPtlMetaDetails = {
  request: (params) => createAction(GET_PTL_DETAILS[REQUEST], { params }),
  success: (response) => createAction(GET_PTL_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_PTL_DETAILS[FAILURE], { response }),
};

export const updatePtlMetaDetails = {
  request: (payload) => createAction(UPDATE_PTL_METADATA_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_PTL_METADATA_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_PTL_METADATA_DETAILS[FAILURE], { response }),
};

export const getGstDetails = {
  request: (payload) => createAction(GET_GST_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(GET_GST_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_GST_DETAILS[FAILURE], { response }),
};
